import { useReducer } from 'react';
import type { TraineeReportFilterInput, TraineeReportSortingRule } from '@/apolloClient.types';
import { TraineeReportSortingField as DefaultSortField, SortingOrder as GqlSortingOrder } from '@/apolloClient.types';
import type { SortOrder as TableSortOrderValue } from '@/components/common/Table/types';
import { SortingOrder as TableSortingOrder } from '@/components/common/Table/types';

// Sort state includes table display value for arrows
type SortRule = TraineeReportSortingRule & { orderValue: TableSortOrderValue | undefined };

export interface State {
    page: number;
    pageSize: number;
    sort: SortRule;
    filter: TraineeReportFilterInput;
}

export interface SetPageAction {
    type: 'SET_PAGE';
    page: number;
}
export interface SetPageSizeAction {
    type: 'SET_PAGE_SIZE';
    pageSize: number;
}
export interface SetSortAction {
    type: 'SET_SORT';
    sortBy: SortRule;
}
export interface SetFilterAction {
    type: 'SET_FILTER';
    filter: TraineeReportFilterInput;
}

export type Action = SetPageAction | SetPageSizeAction | SetSortAction | SetFilterAction;

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'SET_PAGE':
            return { ...state, page: action.page };

        case 'SET_PAGE_SIZE':
            // Reset to page 1 when page size changes
            return { ...state, page: 1, pageSize: action.pageSize };

        case 'SET_SORT':
            // Reset to page 1 when sort changes
            return { ...state, page: 1, sort: action.sortBy };

        case 'SET_FILTER':
            // Reset to page 1 when filter changes
            return { ...state, page: 1, filter: action.filter };

        default:
            return state;
    }
};

const initialState: State = {
    page: 1,
    pageSize: 10,
    sort: {
        field: DefaultSortField.Programme,
        order: GqlSortingOrder.Asc,
        orderValue: TableSortingOrder.Asc,
    },
    filter: {},
};

const useListReducer = () => useReducer(reducer, initialState);

export default useListReducer;
